import { MatchingAside } from '@src/components/sco/Matching/Layout/MatchingAside'
import { MatchingLayout } from '@src/components/sco/Matching/Layout/MatchingLayout'
import { MatchingNav } from '@src/components/sco/Matching/Layout/MatchingNav'
import { MemberMatchingLanding } from '@src/components/sco/Matching/MemberMatchingLanding'
import { useSearchParams } from 'next/navigation'

export default function Page() {
  const queryParams = useSearchParams()

  return (
    <MatchingLayout
      asidePanel={<MatchingAside />}
      mainPanel={<MemberMatchingLanding variantKey={queryParams.get('v') || 'default'} />}
      navPanel={<MatchingNav />}
    />
  )
}
